class InvalidMethodProvidedException extends Error {
  constructor(message) {
    super(message);

    this.name = 'InvalidMethodProvidedException';
    this.details = `Expected a function, ${message}`;
  }
}

export { InvalidMethodProvidedException }; // eslint-disable-line import/prefer-default-export
